import { getPageData } from '@/utils/getPageData';
import { useGetCurrencyUnitsSuspenseInfinite } from 'ap-openapi';
import { useEffect, useMemo } from 'react';

export const useGetCurrencyUnitsAllSuspense = () => {
  const { data, error, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useGetCurrencyUnitsSuspenseInfinite(
      {
        per: 1000,
      },
      {
        query: {
          getNextPageParam: (page) => {
            const url = new URL(page.data.next ?? '/', location.href);
            if (!url.searchParams.has('page')) return undefined;
            return Number(url.searchParams.get('page'));
          },
        },
      }
    );
  if (error) throw error;
  useEffect(() => {
    if (hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [fetchNextPage, hasNextPage, isFetchingNextPage]);
  return useMemo(() => getPageData(data, 'currencies'), [data]);
};
